import React, { useState, useEffect } from "react";
import "../Css_files/Carousel.css";
import { Link } from "react-router-dom";

// Slides Array
const slides = [
  {
    id: 0,
    heading: "Top Global Online Courses for Every Student ",
    subtext: "Join Profenaa Technologies for top-quality online courses across multiple domains, guided by industry experts.",
    image: "https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop",
    category: "Top Online Courses",
    color: "#FF9F1C",
    link: "/all-courses"
  },
  {
    id: 1,
    heading: "Learn Mechanical Design Online",
    subtext: "Master AutoCAD, SolidWorks, and CATIA with step-by-step projects, real-world case studies, and industry tools – all from home.",
    image: "https://images.pexels.com/photos/159298/gears-cogs-machine-machinery-159298.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop",
    category: "Mechanical Engineering Courses",
    color: "#FF6B6B",
    link: "/mech"
  },
  {
    id: 2,
    heading: "Civil Engineering Simplified",
    subtext: "Learn Structural Design, Revit, and STAAD Pro through interactive classes and hands-on assignments built for future civil engineers.",
    image: "https://images.pexels.com/photos/416405/pexels-photo-416405.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop",
    category: "Civil Engineering Courses",
    color: "#4ECDC4",
    link: "/civil"
  },
  {
    id: 3,
    heading: "Electrical & Electronics Online Training",
    subtext: "Explore PLC, MATLAB, SCADA, and embedded systems with guided learning paths designed for job-ready skills in automation & electronics.",
    image: "https://images.pexels.com/photos/442150/pexels-photo-442150.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop",
    category: "Electrical & Electronics Courses",
    color: "#45B7D1",
    link: "/electronics"
  },
  {
    id: 4,
    heading: "Master Coding & IT Skills",
    subtext: "From Python and Web Development to AI & Data Science – get trained by experts and build a strong digital career with online IT courses.",
    image: "https://images.pexels.com/photos/546819/pexels-photo-546819.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop",
    category: "Computer Science & IT Courses",
    color: "#FFEAA7",
    link: "/it"
  },
  {
    id: 5,
    heading: "Creative Arts & Multimedia",
    subtext: "Unleash your creativity with Photoshop, Illustrator, After Effects, Blender, and 3ds Max – learn design & animation online, step by step.",
    image: "https://images.pexels.com/photos/1643383/pexels-photo-1643383.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop",
    category: "Arts & Multimedia Courses",
    color: "#96CEB4",
    link: "/multimedia"
  }
];

const Carousel = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  // Slide auto-change logic
  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, activeSlide === 0 ? 5000 : 3000); // 5s for first slide, 3s for others

    return () => clearInterval(interval);
  }, [activeSlide]);

  const handlePrev = () => {
    setIsAnimating(true);
    setTimeout(() => {
      setActiveSlide((prev) => (prev - 1 + slides.length) % slides.length);
      setIsAnimating(false);
    }, 500);
  };

  const handleNext = () => {
    setIsAnimating(true);
    setTimeout(() => {
      setActiveSlide((prev) => (prev + 1) % slides.length);
      setIsAnimating(false);
    }, 500);
  };

  return (
    <div className="coursel-video-showcase">
      <div className="coursel-video-background">
        {slides.map((slide, index) => (
          <img
            key={slide.id}
            className={`coursel-background-image ${index === activeSlide ? "active" : ""}`}
            src={slide.image}
            alt={slide.category}
          />
        ))}
        <div className="coursel-video-overlay"></div>
      </div>

      <div className="coursel-content-overlay">
        <div className="coursel-container">
          <div className={`coursel-main-content ${isAnimating ? "animating" : ""}`}>
            <div className="coursel-content-wrapper">
              <h1 className="coursel-main-heading">{slides[activeSlide].heading}</h1>

              <p className="coursel-main-subtext">{slides[activeSlide].subtext}</p>

              <div className="coursel-action-buttons">
                <Link
                  to={slides[activeSlide].link}
                  className="coursel-btn-primary"
                >
                  <span>→</span>
                  Explore Course
                </Link>

                <Link to="/contact" className="coursel-btn-secondary">
                  <span>✉</span>
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Navigation Buttons */}
        <div className="coursel-navigation-buttons">
          <button className="coursel-nav-btn coursel-prev-btn" onClick={handlePrev}>
            ←
          </button>
          <button className="coursel-nav-btn coursel-next-btn" onClick={handleNext}>
            →
          </button>
        </div>
      </div>
    </div>
  );
};

export default Carousel;
